import { useTranslation as useInterfaceTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "../../../assets/img/order-details/cross.svg";
import "./index.scss";

interface CompanySelectionModalProps {
  show: boolean;
  onHide: () => void;
  businesses: any[];
  selectedCompany?: any;
  onSelect: (business: any) => void;
  onAddCompany: () => void;
}

function CompanySelectionModal({
  show,
  onHide,
  businesses,
  selectedCompany,
  onSelect,
  onAddCompany
}: CompanySelectionModalProps) {
  const { t: uiT } = useInterfaceTranslation("interface");
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!show) {
      setSearch("");
    }
  }, [show]);

  const filteredBusinesses = useMemo(() => {
    const normalizedSearch = search
      .trim()
      .toLowerCase();

    if (!normalizedSearch) {
      return businesses;
    }

    return businesses.filter((business) =>
      String(business.name || "")
        .toLowerCase()
        .includes(normalizedSearch)
    );
  }, [businesses, search]);

  const handleSelect = (business: any) => {
    onSelect(business);
    onHide();
  };

  const handleAddCompany = () => {
    onHide();
    onAddCompany();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="company-selection-modal"
    >
      <div className="company-selection-head">
        <h4> {uiT("Select company")} </h4>

        <img
          src={CrossIcon}
          alt="close"
          onClick={onHide}
        />
      </div>

      <div className="company-selection-body">
        <div className="company-selection-search">
          <input
            type="text"
            value={search}
            placeholder={uiT("Search by company name")}
            onChange={(event) =>
              setSearch(event.target.value)
            }
            autoFocus
          />
        </div>

        <button
          type="button"
          className="add-company-button"
          onClick={handleAddCompany}
        >
          <span>+</span> {uiT("Add new company")} </button>

        <div className="company-list">
          {filteredBusinesses.length > 0 ? (
            filteredBusinesses.map((business) => {
              const isSelected =
                business.id === selectedCompany?.id;

              return (
                <button
                  type="button"
                  key={business.id}
                  className={
                    isSelected
                      ? "company-list-item selected"
                      : "company-list-item"
                  }
                  onClick={() =>
                    handleSelect(business)
                  }
                >
                  <span className="company-list-name">
                    {business.name}
                  </span>

                  {isSelected && (
                    <span className="selected-company-mark">
                      ✓
                    </span>
                  )}
                </button>
              );
            })
          ) : (
            <div className="company-list-empty"> {uiT("No matching companies")} </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default CompanySelectionModal;